import { ANALYTICS_PERPAY_PLUS_CLICK_HAMBURGER } from '@perpay-web/fintech/constants/actionTypes';

export function analyticsPerpayPlusClickHamburger() {
    return {
        type: ANALYTICS_PERPAY_PLUS_CLICK_HAMBURGER,
    };
}
